const actions = {
  async GET_CLIENT_DATA(context) {
    let devicesTypes = context.dispatch('devices/GET_TYPES');
    let devicesStatuses = context.dispatch('devices/GET_STATUSES');
    let paymentStatuses = context.dispatch('payments/GET_TYPES');

    await Promise.all([devicesTypes, devicesStatuses, paymentStatuses])
  },
  GET_EMPLOYEE_DATA(context) {
    context.dispatch('devices/GET_TYPES');
    // context.dispatch('devices/GET_STATUSES');
  }
};

export default actions;
